import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableTreatedRequest, TableIngoingRequest } from '@features/summary/components/TablesSummary';
import { Stats } from '@features/summary/components/Stats';
import { UserSelect } from '@shared/components/forms/UserSelect';
import { Divider, TextField, IconButton, Tooltip } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import dayjs from 'dayjs';
import BasicsContext from '@shared/context/BasicsContext';
import api from '@shared/api/api';
import { useSummaryProcessedInquiries } from '@features/summary/hooks/useSummaryQueries';
import { useDirectInquiries } from '@features/inquiries/hooks/useInquiryQueries';

// ------------------------------------------------------------ //
//        STYLES
// ------------------------------------------------------------ //
const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },

  column: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  rowAboveTable: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  divider: {
    marginLeft: '1em',
    marginRight: '1em',
  },
}));

// ------------------------------------------------------------ //
//        COMPONENT
// ------------------------------------------------------------ //
const TabSummary = () => {

  const classes = useStyles();
  const basics = useContext(BasicsContext);
  const user = basics ? basics.user : null;
  const [userId, setUserId] = useState(user.id);

  const [switchmanId, setSwitchmanId] = useState(null);
  const [teacherId, setTeacherId] = useState(null);

  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [reload, setReload] = useState(false);

  // Calculer le timestamp from
  const timestampFrom = dayjs(date, "YYYY-MM-DD").unix();

  // Utilisation des hooks React Query
  const { data: processed = [] } = useSummaryProcessedInquiries(timestampFrom, null, userId);
  const { data: direct = {}, refetch: refetchDirectInquiries } = useDirectInquiries();

  // Extraire les propriétés avec valeurs par défaut
  const {
    waitingSwitchman = [],
    withSwitchman = [],
    waitingTeacher = [],
    withTeacher = []
  } = direct;

  // Filtrer les requêtes directes selon l'utilisateur
  const directInquiries = [
    ...waitingSwitchman.filter(inquiry =>
      inquiry.teacher_id === teacherId || inquiry.switchman_id === switchmanId
    ),
    ...withSwitchman.filter(inquiry =>
      inquiry.teacher_id === teacherId || inquiry.switchman_id === switchmanId
    ),
    ...waitingTeacher.filter(inquiry =>
      inquiry.teacher_id === teacherId || inquiry.switchman_id === switchmanId
    ),
    ...withTeacher.filter(inquiry =>
      inquiry.teacher_id === teacherId || inquiry.switchman_id === switchmanId
    )
  ];

  useEffect(() => {
      // Reset IDs before fetching new user info
      setTeacherId(null);
      setSwitchmanId(null);

      api.getUserInfo(userId)
        .then(function(response) {
          const {role, user} = response;

          if(role === "teacher") {
            setTeacherId(user.teacher_id);
          }

          if(role === "switchman") {
            setSwitchmanId(user.switchman_id);
          }

          refetchDirectInquiries();
        });

  }, [userId, date, reload, refetchDirectInquiries]);

  return (
    <div className={classes.row}>
      <div className={classes.column}>

        <div className={classes.rowAboveTable}>
          <TextField
            id="date"
            label="Date à afficher"
            type="date"
            margin="dense"
            variant="outlined"
            value={date}
            onChange={(event) => {
              setDate(event.target.value);
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <UserSelect userId={userId} setUserId={setUserId} />
          
          <Tooltip title="Rafraichir">
            <IconButton aria-label="refresh" onClick={() => {
                setReload(!reload);
              }}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </div>

        <TableTreatedRequest date={date} userId={userId} data={processed} />
        
        <TableIngoingRequest date={date} userId={userId} data={directInquiries} />
        
        {' '}
      </div>

      {/* <Divider className={classes.divider} orientation="vertical" flexItem />

      <div className={classes.column}>
        <Stats date={date} reload={reload} setReload={setReload} user={{ id: userId, teacher_id: teacherId, switchman_id: switchmanId }} />
      </div> */}
    </div>
  );
};

export default TabSummary;